module.exports = __webpack_public_path__ + "img/project12.4544feea.jpg";